<template lang="pug">
  div.margin-top-5
    el-row(
      :gutter="20"
      v-for="(item, index) in itemList"
      :key="index"
    )
      el-form(
        :model="item"
        :rules="rules"
        ref="form-criteria"
      )
        el-col(:span="1") &nbsp;
        el-col(:span="11")
          el-form-item(prop="name")
            el-input(v-model="item.name" size="small" placeholder="Variable name")
        el-col(:span="7")
          el-form-item(prop="value")
            el-input(v-model="item.value" size="small" placeholder="Variable value")
        el-col(:span="3" style="text-align: right")
          el-button(
            type="danger"
            size="small"
            icon="el-icon-delete"
            @click="removeItem(index)"
          )
    el-row
      el-col(:span="24")
        el-button.margin-top-20(
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="addItem"
        ) Add Item



</template>

<script>
  export default {
    props: {
      itemList: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        rules: {
          name: [
            {
              required: true,
              message: 'Name is required',
              trigger: 'blur',
            },
          ],
          value: [
            {
              required: true,
              message: 'Value is required',
              trigger: 'blur',
            },
          ],
        },
      }
    },

    mounted() {
      if (!this.itemList.length) {
        this.addItem()
      }
    },

    methods: {
      addItem() {
        this.itemList.push({ name: '', value: '' })
      },

      removeItem(index) {
        this.itemList.splice(index, 1)
      },

      validateAll() {
        let isValid = true
        for (const form of this.$refs['form-criteria']) {
          form.validate(valid => {
            isValid = isValid && valid
          })
        }
        return isValid
      },
    },
  }
</script>